<template lang="html">
  <div class="worker-list">
    <div class="banner" v-if="banner && banner.length > 0">
      <swipe :auto="3000">
        <swipe-item v-for="(item, index) in banner" :key="index">
          <a :href="item.link">
            <img v-lazy="$$viewImage(item.image, 750, 300)" />
          </a>
        </swipe-item>
      </swipe>
    </div>
    <div class="store-info">
      <div class="store-info-inner">
        <p class="storeName" :class="{ hasStore: storeName }">
          <i class="iconfont icon-weizhi1"></i>{{ storeName || '按门店预览' }}
        </p>
        <p class="changeStore" @click="changeStore">
          切换门店<i class="iconfont icon-xiajiantou"></i>
        </p>
      </div>
    </div>
    <loadData
      viewName="storeAllWorkers"
      :fetchData="list"
      :fetchMethod="getWorker"
      :controlPage="changePage"
      :page="pageIndex"
      :pageSize="pageSize"
      :firstFetch="firstFetch"
      :hasErr="hasErr"
      :otherParams="{ errText: '暂无育儿顾问' }"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Swipe, SwipeItem } from 'mint-ui'
import loadData from '@/components/loadMore'
import { isArray } from '@/utils'

export default {
  PAGE_ID: '121011911',
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      list: [],
      firstFetch: true,
      hasErr: false,
      banner: [],
      cityName: '',
      cityCode: '',
      storeName: '',
      storeCode: '',
      queryUserType: '',
      defaultCityCode: '320100',
      defaultCityName: '南京',
      searchCity: '',
      searchCityName: ''
    }
  },
  created() {
    this.trackView()
    this.trackBT(121012452)()
    const query = this.$route.query
    this.cityName = query.cityname || query.city_name
    this.cityCode = query.cityid || query.city_code || this.defaultCityCode
    this.storeName = query.entityname || query.storeName
    this.storeCode = query.entityid || query.store_code
    this.searchCity = this.cityCode
    this.searchCityName = this.cityName
    if (!this.searchCityName) {
      this.getCity()
    }
    if (this.storeCode) {
      this.queryUserType = query.userTypes
        ? query.userTypes.split(',')
        : [1, 3, 4]
      this.$$title('门店服务人员')
    } else {
      this.queryUserType = query.userTypes ? query.userTypes.split(',') : [1]
      this.$$title('同城育儿顾问')
    }
    if (this.storeCode) {
      this.getStore()
    }
    this.getBanner()
    this.getWorker()
    // this.$$tracker('230101', '10000', '11042')
    this.$$loading(false)
  },
  mounted() {
    this.$$allowRefreshOrShare(false, true)
  },
  methods: {
    changeStore() {
      this.$$tracker('121011911', '20000', '200001')
      const url = encodeURIComponent(window.location.href)
      window.location.href = `//w.cekid.com/store/store-list.html?referer=${url}`
    },
    searchData() {
      this.page = 1
      this.firstFetch = true
      this.hasErr = false
      this.getWorker()
    },
    async getCity() {
      const city = await this.$store.dispatch('getNameById', {
        addressId: this.searchCity
      })
      this.searchCityName = city.NAME.replace('市', '')
      if (!this.storeCode) {
        this.$$share({
          desc: '孩子王，让每个童年更美好',
          title: `${this.searchCityName}孩子王育儿顾问团队为您服务`
        })
      }
    },
    async getStore() {
      const store = await this.$store.dispatch('getStoreByCode', {
        storeCode: this.storeCode
      })
      if (store && store.code === 1001) {
        this.storeName = store.data.store_desc
      }
    },
    async getBanner() {
      const config = await this.$store.dispatch('getCmsConfig4StoreWorkers')
      if (
        config &&
        config.data &&
        config.data.storeTeam.promotions &&
        config.data.storeTeam.promotions.length > 0
      ) {
        this.banner = config.data.storeTeam.promotions.filter(
          ele => ele.image !== '' && ele.link !== ''
        )
      }
    },
    async getWorker() {
      try {
        if (this.pageIndex === 1) {
          this.list.length = 0
          this.list = []
        }
        let userTypes = this.queryUserType
        if (isArray(this.queryUserType)) {
          userTypes = this.queryUserType.filter(x => +x !== 99)
        }
        this.queryUserType.filter
        // console.log(this.searchCityName)
        const workerlist = await this.$store.dispatch('getAllWorkers', {
          cityId: this.searchCity,
          storeCode: this.storeCode,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
          userTypes
        })
        if (workerlist.length > 0) {
          this.list.push(...(workerlist || []))
        } else if (
          this.pageIndex === 1 &&
          !this.storeCode &&
          this.searchCity !== this.defaultCityCode
        ) {
          this.searchCity = this.defaultCityCode
          this.searchCityName = this.defaultCityName
          await this.getWorker()
        }

        this.firstFetch = false
      } catch (e) {
        this.firstFetch = false
        // this.$$toast('网络异常，请刷新重试')
        this.hasErr = true
      }
    },
    // async getEnumData() {
    //     await this.$store.dispatch('getWorkerEnumData')
    // },
    changePage(pageIndex) {
      this.pageIndex = pageIndex
    }
  },
  components: {
    loadData,
    Swipe,
    SwipeItem
  }
}
</script>
<style lang="scss">
#vproduct_app {
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.worker-list {
  position: relative;
  .banner {
    position: relative;
    background-color: #fff;
    height: rem(300px);

    img {
      display: block;
      width: 100%;
      height: rem(300px);
    }
  }
  .store-info {
    background-color: #f4f4f4;
    padding-bottom: rem(20px);
    color: #999;

    .store-info-inner {
      background-color: #fff;
      height: rem(100px);
      display: flex;
      align-items: center;
      padding: 0 rem(25px);
    }

    .storeName {
      flex: 1;
      font-size: rem(28px);
      .iconfont {
        padding-right: rem(12px);
      }
    }
    .hasStore {
      color: #121212;
    }
    .changeStore {
      font-size: rem(24px);

      .iconfont {
        padding-left: rem(12px);
        font-size: rem(28px);
      }
    }
  }
}
</style>
